module.exports = __webpack_public_path__ + "static/img/icon8.16ac042b.png";